module.exports = __webpack_public_path__ + "976c853ae9062409996c7172b271d6bb.svg";